
import { defineComponent, PropType, ref } from "vue";
import { QuestionnaireItem } from "@/modules/questionnaire/questionnaireInfo";
import QuestionnaireHeader from "@/components/Questionnaire/QuestionnaireHeader.vue";
import QuestionnaireFooter from "@/components/Questionnaire/QuestionnaireFooter.vue";
import { useRoute, useRouter } from "vue-router";
import { QuestionnaireUserItem } from "@/modules/questionnaire/questionnaireUserItem";
import { checkQueryParams } from "@/commons/questionnaire/questionnaire";

export default defineComponent({
    name: "QuestionnaireParent",
    components: {
        QuestionnaireHeader,
        QuestionnaireFooter,
    },
    props: {
        acceptCallbackUrls: { type: Array as PropType<string[]>, required: true },
    },
    setup(props) {
        const router = useRouter();
        const route = useRoute();
        const codeChallenge = (route.query.code_challenge) ? route.query.code_challenge as string : route.query.codeChallenge as string;
        const callback = route.query.callback as string;
        const siteCode = route.query.site_code as string;
        const mmFlg = (route.query.mm_flg || null) as string | null;
        const mmExtId = (route.query.mm_ext_id || null) as string | null;

        const waitViewRef = ref(false);

        // 連携情報をprovide
        const questionnaireItem = QuestionnaireItem.create();
        const routeNames = questionnaireItem.routeNames;

        if (callback || siteCode) {
            questionnaireItem.setLinkageInfo({
                codeChallenge: codeChallenge,
                callbackUrl: callback,
                siteCode: siteCode,
                mmFlg: mmFlg,
                mmExtId: mmExtId,
                callbackUrlWithToken: null
            });
            questionnaireItem.storeStorage();
        }
        questionnaireItem.provide();

        // コールバックチェック
        let isValidCallback = true;
        if (callback) {
            isValidCallback = Boolean(props.acceptCallbackUrls.find(urlRegex => callback.match(RegExp(urlRegex, "g"))));
        }

        // クエリパラメータチェック
        const isValidQueryParam = checkQueryParams(questionnaireItem.questionnaireInfo);

        // 基本属性情報をprovide
        const userBaseItem = QuestionnaireUserItem.create();
        userBaseItem.provide();

        // 必須情報の形式不正・情報不足の場合（クエリにもセッションストレージにも無い場合）はエラー画面へ
        if (!questionnaireItem.questionnaireInfo.callbackUrl || !questionnaireItem.questionnaireInfo.codeChallenge || !questionnaireItem.questionnaireInfo.siteCode || !isValidCallback || !isValidQueryParam) {
            router.push({ name: routeNames.GENERAL_ERROR, params: { message: "URLに不備があります" } }).finally(() => waitViewRef.value = true);
        } else {
            waitViewRef.value = true;
        }

        return {
            waitViewRef
        };
    }
});
